import { Navigate, NavLink, Route, Routes as Switch } from 'react-router-dom';

import { Tab, TabGroup } from '@servicetitan/design-system';
import { Flex } from '@servicetitan/anvil2';

import { ConfigurationRoutes } from '../../utils/routes';
import { getNavClickHandler } from '../../../common/utils/get-nav-click-handler';
import { EmailDirectMail } from './configuration/email-direct-mail';
import { Sms } from './configuration/sms';
import { TitleWithOpenDetails } from '../configuration-helpers/title-with-open-details';

export const TenantConfiguration = () => {
    return (
        <Flex direction="column" gap={4}>
            <TitleWithOpenDetails title="Configuration" />
            <div>
                <TabGroup className="m-b-3">
                    <NavLink to={ConfigurationRoutes.emailDirectMail} end>
                        {({ isActive }) => (
                            <Tab active={isActive} onClick={getNavClickHandler(isActive)}>
                                Email & Direct Mail
                            </Tab>
                        )}
                    </NavLink>
                    <NavLink to={ConfigurationRoutes.sms}>
                        {({ isActive }) => (
                            <Tab active={isActive} onClick={getNavClickHandler(isActive)}>
                                SMS
                            </Tab>
                        )}
                    </NavLink>
                </TabGroup>
                <Switch>
                    <Route
                        path={ConfigurationRoutes.emailDirectMail}
                        element={<EmailDirectMail />}
                    />
                    <Route path={ConfigurationRoutes.sms} element={<Sms />} />
                    <Route
                        path="*"
                        element={<Navigate to={ConfigurationRoutes.emailDirectMail} replace />}
                    />
                </Switch>
            </div>
        </Flex>
    );
};
